const questionControlStatsByStatus = (data, status) =>
  data?.map((category) =>
    category.stats[status] !== undefined ? category.stats[status] : 0,
  )

export default questionControlStatsByStatus
